import React from "react";
import { FormattedMessage } from "react-intl";
import StyledLink from "../../../shared/StyledLink/StyledLink";
import "./together.scss";
const Together = () => {
  return (
    <div className="home-together">
      <h1 className="big-title">
        <FormattedMessage
          id="Work"
          defaultMessage="Let's work together"
        />
      </h1>
      <StyledLink
        to="/"
        styles="styled"
        linkName={
          <FormattedMessage
            id="WithUs"
            defaultMessage="Work with us"
          />
        }
      />
      <div className="img"></div>
    </div>
  );
};

export default Together;
